import { schema } from 'normalizr';

export const processSchema = new schema.Entity('processes', {}, { idAttribute: 'ProcessId' });

export const processListSchema = [processSchema];
